import { compose } from "redux";
import React, { PureComponent } from "react";
import { Grid, withStyles } from "@material-ui/core";

import { BasePage as AltusBasePage } from "altus-ui-components";

class BasePage extends PureComponent {
  render() {
    const { classes, ...rest } = this.props;

    return (
      <Grid item xs container justifyContent="center">
        <Grid container item xs={12} md={10}>
          <AltusBasePage
            classes={{
              children: classes.basePageChildren,
            }}
            {...rest}
          />
        </Grid>
      </Grid>
    );
  }
}

const styles = theme => ({
  basePageChildren: {
    padding: `${theme.spacing(5)}px ${theme.spacing(2)}px`,
  },
});

export default compose(withStyles(styles))(BasePage);
